export default __webpack_public_path__ + "static/media/Jumbo_printing_rules_inches.ac1c5b95.pdf";